import styled from 'styled-components'
import { Button } from '@material-ui/core'

const RainBowButton = styled(Button)`
    /* IE10+ */ 
    background-image: -ms-linear-gradient(top, #FFFFFF 0%, #FAFBFD 100%) !important;
    /* Mozilla Firefox */ 
    background-image: -moz-linear-gradient(top, #FFFFFF 0%, #FAFBFD 100%) !important;
    /* Opera */ 
    background-image: -o-linear-gradient(top, #FFFFFF 0%, #FAFBFD 100%) !important;
    /* Webkit (Safari/Chrome 10) */ 
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #FFFFFF), color-stop(100, #FAFBFD)) !important;
    /* Webkit (Chrome 11+) */ 
    background-image: -webkit-linear-gradient(top, #FFFFFF 0%, #FAFBFD 100%) !important;
    /* W3C Markup */ 
    background-image: linear-gradient(to bottom, #FFFFFF 0%, #FAFBFD 100%) !important;
    color: #000000 !important;
    border: 1px solid rgb(229, 230, 230) !important;
    height: auto !important;
`;

export default RainBowButton;